export const useValidatedDetailChangeByKey =
  (setFormData, setErrors) =>
  (listKey, index, field, validator) =>
  (e) => {
    const raw = e.target.value;
    const { value, error } = validator(raw);

    // error 更新
    setErrors((prev) => {
      const next = { ...prev };
      if (!next[listKey]) next[listKey] = [];
      if (!next[listKey][index]) next[listKey][index] = {};
      next[listKey][index][field] = error;
      return next;
    });

    if (value === null) return;

    setFormData((prev) => {
      const list = [...prev[listKey]];
      list[index] = {
        ...list[index],
        [field]: value,
      };
      return { ...prev, [listKey]: list };
    });
  };
